import { render, staticRenderFns } from "./EnterUserDetails.vue?vue&type=template&id=643aff59"
import script from "./EnterUserDetails.vue?vue&type=script&lang=js"
export * from "./EnterUserDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports